import React from 'react'

import css from './item-select-container.module.scss'

type ItemSelectContainerProps = {
  children: React.ReactNode
}

const ItemSelectContainer = ({ children }: ItemSelectContainerProps) => {
  return (
    <div className={css.container}>
      <ul className={css.itemSelectList}>{children}</ul>
    </div>
  )
}

export default ItemSelectContainer
